/**
 *
 * @param object
 * @param separator
 * @returns Single-depth Object, with keys separated by given @param
 */
export const flattenObject = (object, separator = ".") => {
  let result = {};
  for (const key in object) {
    if (typeof object[key] === "object" && !Array.isArray(object[key])) {
      const temp = flattenObject(object[key], separator);
      for (const tempKey in temp) {
        result[key + separator + tempKey] = temp[tempKey];
      }
    } else {
      result[key] = object[key];
    }
  }
  return result;
};
